import { services } from "../../../../api"

export const getDrugDiseaseDetails = async (id: number, isDisease: boolean) => {
    try {
    const func = isDisease ? services.diseases.getDiseasesDetails : services.drugs.getDrugDetails;
    const res = await func(id);
    if (res.result !== 'success') {
        throw new Error('error');
    }
    return res.content.sections;
    } catch (ex) {
        return [];
    }
} 